import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import ForcePasswordChangeDialog from "./ForcePasswordChangeDialog";
import logger from "../lib/logger";

export default function ProtectedRoute({ children, allowedRoles = null, requiredPermission = null }) {
    const { user, loading, checkAuth, setUser, hasPermission } = useAuth();
    const location = useLocation();
    const [showPasswordChange, setShowPasswordChange] = useState(false);

    useEffect(() => {
        logger.debug("[ProtectedRoute] useEffect triggered", { hasUser: !!user, loading });
        if (!user && !loading) {
            logger.debug("[ProtectedRoute] Calling checkAuth because no user and not loading");
            checkAuth();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, loading]);

    useEffect(() => {
        if (user?.must_change_password) {
            setShowPasswordChange(true);
        }
    }, [user]);

    if (loading) {
        logger.debug("[ProtectedRoute] Rendering loading spinner (loading=true)");
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="animate-pulse text-primary font-heading text-xl">Cargando...</div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check roles (legacy support)
    if (allowedRoles && !allowedRoles.includes(user.role) && user.role !== "super_admin") {
        return <Navigate to="/dashboard" replace />;
    }

    // Check specific permission
    if (requiredPermission && !hasPermission(requiredPermission[0], requiredPermission[1])) {
        return <Navigate to="/dashboard" replace />;
    }

    // Force password change if required
    if (showPasswordChange) {
        return (
            <ForcePasswordChangeDialog
                open={true}
                onSuccess={() => {
                    setShowPasswordChange(false);
                    setUser({ ...user, must_change_password: false });
                }}
            />
        );
    }

    return children;
}
